import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { PrimengModule } from '@modules/primeng.module';

import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { ConfiguracaoCaixaComponent } from './components/configuracao-caixa.component';
import { AddContaCaixaDialogComponent } from './components/dialogs/add-conta-caixa-dialog/add-conta-caixa-dialog.component';
import { ConfiguracaoCaixaApiService } from './services/configuracao-caixa-api.service';
import { ContaBancoDialogComponent } from './components/dialogs/conta-banco-dialog/conta-banco-dialog.component';
import { MesclarContasDialogComponent } from './components/dialogs/mesclar-contas-dialog/mesclar-contas-dialog.component';
import { AlterarContaDoTipoDialogComponent } from './components/dialogs/alterar-conta-do-tipo-dialog/alterar-conta-do-tipo-dialog.component';
import { AdicionarTipoDialogComponent } from './components/dialogs/adicionar-tipo-dialog/adicionar-tipo-dialog.component';
import { MesclarTiposDialogComponent } from './components/dialogs/mesclar-tipos-dialog/mesclar-tipos-dialog.component';
import { ConfiguracaoCaixaArquivadasComponent } from './components/configuracao-caixa-arquivadas/configuracao-caixa-arquivadas.component';
import { ConfiguracaoCaixaAtivasComponent } from './components/configuracao-caixa-ativas/configuracao-caixa-ativas.component';
import { ConfiguracaoCaixaResolver } from './resolvers/configuracao-caixa.resolver';
import { ContasArquivadasResolver } from './resolvers/contas-arquivadas.resolver';
import { ContaCaixaTableComponent } from './components/conta-caixa-table/conta-caixa-table.component';
import { TravaContaCaixaDialogComponent } from './components/dialogs/trava-conta-caixa-dialog/trava-conta-caixa-dialog.component';
import { AlterarContaEmMassaDialogComponent } from './components/dialogs/alterar-conta-em-massa-dialog/alterar-conta-em-massa-dialog.component';
import { MesclarTiposEmMassaDialogComponent } from './components/dialogs/mesclar-tipos-em-massa-dialog/mesclar-tipos-em-massa-dialog.component';


@NgModule({
  declarations: [
    ConfiguracaoCaixaComponent,
    AddContaCaixaDialogComponent,
    ContaBancoDialogComponent,
    MesclarContasDialogComponent,
    AlterarContaDoTipoDialogComponent,
    AdicionarTipoDialogComponent,
    MesclarTiposDialogComponent,
    ConfiguracaoCaixaAtivasComponent,
    ConfiguracaoCaixaArquivadasComponent,
    ContaCaixaTableComponent,
    TravaContaCaixaDialogComponent,
    AlterarContaEmMassaDialogComponent,
    MesclarTiposEmMassaDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    { provide: ConfiguracaoCaixaApiService, useClass: ConfiguracaoCaixaApiService },
    ConfiguracaoCaixaResolver,
    ContasArquivadasResolver,
  ],
})
export class ConfiguracaoCaixaModule { }
